export enum CorrectionsBillQueryParamsUrlEnum {
    main = 'proNbr',
    requestId = 'requestId',
    correctionRequestInstId = 'correctionRequestInstId',
    requestDateTime = 'requestDateTime',
    completeDate = 'completeDate',
    pickupDate = 'pickupDate',
};
